import { z } from "zod";
import type { SpotlightTarget } from "@/lib/spotlight";

export const PROFILE_SECTIONS = [
  "profil",
  "apparence",
  "notifications",
  "calendrier",
  "sessions",
] as const;

export type ProfileSection = (typeof PROFILE_SECTIONS)[number];

export const profileSearchSchema = z.object({
  section: z.enum(PROFILE_SECTIONS).optional().catch(undefined),
});

/** Existing announcement links must land on the now-separate settings section. */
export function profileSectionForSpotlight(target?: SpotlightTarget): ProfileSection | undefined {
  if (target === "profile-appearance") return "apparence";

  if (target === "profile-sessions") return "sessions";

  if (target === "profile-identity") return "profil";

  return undefined;
}
